var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NumberField as BaseNumberField } from '@base-ui/react/number-field';
import { Box, IconButton, InputLabel, FormControl } from '@mui/material';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
var CNumberField = function (_a) {
    var value = _a.value, onChange = _a.onChange, min = _a.min, max = _a.max, _b = _a.step, step = _b === void 0 ? 1 : _b, label = _a.label, disabled = _a.disabled, _c = _a.size, size = _c === void 0 ? 'medium' : _c, _d = _a.fullWidth, fullWidth = _d === void 0 ? false : _d, sx = _a.sx;
    var height = size === 'small' ? 40 : 56;
    return (_jsx(BaseNumberField.Root, __assign({ value: value, onValueChange: function (val) { return onChange === null || onChange === void 0 ? void 0 : onChange(val); }, min: min, max: max, step: step, disabled: disabled }, { children: _jsxs(FormControl, __assign({ size: size, fullWidth: fullWidth, disabled: disabled, sx: sx }, { children: [label && (_jsx(InputLabel, __assign({ shrink: true, sx: {
                        bgcolor: 'background.paper',
                        px: 0.5,
                        '&.Mui-focused': { color: 'primary.main' },
                    } }, { children: label }))), _jsxs(BaseNumberField.Group, __assign({ render: _jsx(Box, { sx: {
                            display: 'flex',
                            alignItems: 'center',
                            height: height,
                            border: 1,
                            borderColor: 'rgba(0, 0, 0, 0.23)',
                            borderRadius: 1,
                            bgcolor: disabled ? 'action.disabledBackground' : 'transparent',
                            '&:hover': {
                                borderColor: disabled ? undefined : 'text.primary',
                            },
                            '&:focus-within': {
                                borderColor: 'primary.main',
                                outline: '1px solid',
                                outlineColor: 'primary.main',
                            },
                        } }) }, { children: [_jsx(BaseNumberField.Decrement, { render: _jsx(IconButton, __assign({ size: "small", disabled: disabled, sx: { ml: 0.5 } }, { children: _jsx(RemoveIcon, { fontSize: "small" }) })) }), _jsx(BaseNumberField.Input, { style: {
                                flex: 1,
                                border: 'none',
                                outline: 'none',
                                background: 'transparent',
                                textAlign: 'center',
                                fontSize: size === 'small' ? '0.875rem' : '1rem',
                                fontFamily: 'inherit',
                                color: 'inherit',
                                width: '100%',
                                minWidth: 0,
                            }, disabled: disabled, 
                            // This prevents from typing the large numbers > max
                            onKeyDown: function (e) {
                                var _a, _b;
                                if (!/^\d$/.test(e.key))
                                    return;
                                var input = e.currentTarget;
                                var newStr = input.value.slice(0, (_a = input.selectionStart) !== null && _a !== void 0 ? _a : 0) +
                                    e.key +
                                    input.value.slice((_b = input.selectionEnd) !== null && _b !== void 0 ? _b : 0);
                                var parsed = parseFloat(newStr);
                                if (!isNaN(parsed) && max !== undefined && parsed > max) {
                                    e.preventDefault();
                                }
                            } }), _jsx(BaseNumberField.Increment, { render: _jsx(IconButton, __assign({ size: "small", disabled: disabled, sx: { mr: 0.5 } }, { children: _jsx(AddIcon, { fontSize: "small" }) })) })] }))] })) })));
};
export default CNumberField;
